export default function Selected(props) {
    const { selectedOptions } = props
    return (
        <span className={`w-fit whitespace-nowrap inline-flex items-center py-1 px-2 mr-2 text-sm font-medium rounded-lg text-indigo-800 bg-indigo-100`}>
            {selectedOptions}
        </span>
    )
}